var map = {
	"./action.svg": 24,
	"./add.svg": 11,
	"./address-location.svg": 16,
	"./arrow-down.svg": 12,
	"./arrow-to-left.svg": 25,
	"./arrow-to-right.svg": 10,
	"./arrow-to-top.svg": 26,
	"./arrow-up.svg": 13,
	"./arrow_right.svg": 27,
	"./arrows-back.svg": 17,
	"./avatar.svg": 28,
	"./back.svg": 29,
	"./checked.svg": 30,
	"./checked2.svg": 31,
	"./circle-cross.svg": 18,
	"./clear.svg": 32,
	"./close.svg": 33,
	"./collectic.svg": 34,
	"./cross.svg": 35,
	"./down.svg": 19,
	"./ellipsis.svg": 36,
	"./finish.svg": 14,
	"./github.svg": 37,
	"./hook-red.svg": 20,
	"./message.svg": 38,
	"./minus.svg": 39,
	"./more.svg": 40,
	"./more2.svg": 41,
	"./more3.svg": 42,
	"./nav.svg": 43,
	"./notice.svg": 44,
	"./plus.svg": 45,
	"./process.svg": 46,
	"./processed.svg": 47,
	"./qr.svg": 48,
	"./rate-default-img.svg": 49,
	"./reduce.svg": 15,
	"./right.svg": 50,
	"./search.svg": 51,
	"./search2.svg": 52,
	"./search3.svg": 53,
	"./set.svg": 54,
	"./share.svg": 55,
	"./star.svg": 56,
	"./tick-red.svg": 21,
	"./tick.svg": 57,
	"./top.svg": 58,
	"./trolley.svg": 59,
	"./unchecked.svg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;